<template>
    <v-container fluid grid-list-sm>
        <v-row>
            <v-col cols="12" sm="9">
                <h3 class="display-1 primary--text">Periods</h3>
            </v-col>
            <v-col cols="12" sm="3">
                <v-btn @click="createPeriod" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
            </v-col>
            <v-col cols="12" sm="12">
                <v-data-table :loading="isLoading" :headers="headers" :items="p" class="elevation-1 mt-5">
                    <template v-slot:item.startDate="{item}">
                        {{item.startDate | moment('DD/MM/YYYY')}}
                    </template>
                    <template v-slot:item.endDate="{item}">
                        {{item.endDate | moment('DD/MM/YYYY')}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-icon color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                        <v-icon color="error" class="mr-2" @click="archivePeriod(item)">mdi-delete</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    export default {
        name: "Periods",
        computed: {
            ...mapState("periods", ["periods"]),
            p: {
                get() {
                    return this.periods;
                }
            }
        },
        methods: {
            ...mapActions("periods", ["setActivePeriod", "setManagePeriodDialog", "setPeriods", "setManageDeletePeriodDialog"]),
            async editItem(item) {
                await this.setActivePeriod(item);
                await this.setManagePeriodDialog(true);
            },
            async createPeriod() {
                await this.setActivePeriod({});
                await this.setManagePeriodDialog(true);
            },
            async archivePeriod(item) {
                await this.setActivePeriod(item);
                await this.setManageDeletePeriodDialog(true);
            }
        },
        data() {
            return {
                isLoading: false,
                search: '',
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Start', value: 'startDate' },
                    { text: 'End', value: 'endDate' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
